<template>
  <div class="asset-table-display">
    <v-row class="hidden-sm-and-down ml-0">
      <v-col cols="12" md="5" caption>
        <strong>Title</strong>
      </v-col>
      <v-col cols="12" md="5">
        <strong>Description</strong>
      </v-col>
      <v-col cols="12" md="2">
        <strong>Actions</strong>
      </v-col>
    </v-row>

    <v-row
      v-for="(assetItem, index) in assets"
      :key="index"
      class="ml-0"
      :class="index !== assets.length - 1 && 'asset-table-display__divider'"
    >
      <v-col cols="12" md="5">
        <div class="hidden-md-and-up mb-1">
          <strong>Title</strong>
        </div>
        <v-row no-gutters>
          <img
            :src="getAssetIcon(assetItem.asset)"
            class="asset-table-display__asset-icon"
            alt=""
          />
          <v-col class="pa-0 pl-2">
            {{ assetItem.title }}
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="5">
        <div class="hidden-md-and-up mb-1">
          <strong>Description</strong>
        </div>
        <div>{{ assetItem.description }}</div>
      </v-col>

      <v-col cols="12" md="2">
        <div class="hidden-md-and-up mb-1">
          <strong>Actions</strong>
        </div>

        <button
          :aria-label="assetAriaLabel(assetItem.asset)"
          target="_blank"
          class="primary--text underline text-left"
          @click="onDownload(assetItem.asset)"
        >
          <strong
            >Download
            <span class="d-md-block"
              >({{ fileSize(assetItem.asset) }} MB)</span
            ></strong
          >
        </button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getAssetIcon } from "~/plugins/utilities/getAssetDetails";

export default {
  name: "AssetTableDisplay",
  props: {
    assets: { type: Array, default: undefined },
    item: { type: Object, default: undefined },
  },
  methods: {
    onDownload(asset) {
      const url = asset.original?.url;

      if (url) {
        window.open(url, "_blank");
      }
    },
    assetAriaLabel(asset) {
      return `download file ${asset.fileName} ${this.fileSize(
        asset
      )} MB [opens in a new tab]`;
    },
    fileSize(asset) {
      if (asset?.fileSizeMegabytes) {
        if (asset.fileSizeMegabytes > 1) {
          return Math.floor(asset.fileSizeMegabytes).toString();
        }

        return asset.fileSizeMegabytes.toFixed(2);
      }

      return undefined;
    },
    getAssetIcon,
  },
};
</script>

<style lang="scss" scoped>
.asset-table-display {
  &__asset-icon {
    height: 28px;
    width: 28px;
  }

  @media only screen and (max-width: 959px) {
    &__divider {
      border-bottom: solid 2px var(--v-softened-base);
    }
  }
}
</style>
